import { longDate } from './usDate';

const startOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

/**
 * "Today", "Yesterday", "3 days ago", then a date: the day something happened,
 * as the record says it. `now` is a parameter so the words can be tested.
 */
export const relativeDay = (value, now = new Date()) => {
  if (!value) return '';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const days = Math.round((startOfDay(now) - startOfDay(date)) / 86400000);

  if (days <= 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 7) return `${days} days ago`;

  return longDate(date);
};
